import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getMasterOptions, setAccountDataInOption, getGeneralSetting, getAccountMasterOptions } from '@/redux/actions';
import { selectAuth, selectAccountOptions, selectBookOptions } from '@/redux/selector';
import { MODULE_IDS } from '@/components/PermissionsContext';
import * as _ from 'lodash';

export const CommonCall = () => {
    const dispatch = useDispatch();
    const auth = useSelector(selectAuth, shallowEqual);
    const accounts = useSelector(selectAccountOptions, shallowEqual);
    const books = useSelector(selectBookOptions, shallowEqual);

    useEffect(() => {
        if (auth?.company?.id && auth?.customer?.id) {
            dispatch(getMasterOptions(MODULE_IDS.BOOK, true));
            // dispatch(getMasterOptions(MODULE_IDS.ACCOUNT, true));
            dispatch(getAccountMasterOptions(true));
            dispatch(getMasterOptions(`${MODULE_IDS.ITEM}`));
            dispatch(getGeneralSetting());
        }
    }, [auth.company?.id]);

    useEffect(() => {
        if (accounts) {
            let data = [];
            const active = [];
            const map = new Map();

            const bookAccounts = books.map((book) => parseInt(book.Account_Id));
            accounts
            .filter((data) => (!bookAccounts.includes(data.id) && !data.isSystem))
            .forEach((account) => {
                // if (!account.DeActive) {
                    if (account.Addresses?.length) {
                        account.Addresses.forEach((address) => {
                            const add = [address.Address1, address.Address2, address.Address3, address?.State?.State_Name].filter((data) => data);
                            const newAccount = {
                                ...account,
                                Address_Id: address.id || null,
                                Broker: account?.Broker?.Brocker_Name,
                                BrokerData: account?.Broker,
                                Schedule: account?.Schedule?.Schedule_Name,
                                Transporter: account?.Transporter?.Transporter_Name,
                                Address: `${add.join(', ')}`,
                                City: address.City,
                                DeActive: account.DeActive ? 'Yes' :  'No',
                                isActive: !account.DeActive,
                                accountId: account.id,
                                gstLedger: `${account.GSTIN_No || ''} \n\n(${account.ledgerAmount || '0.00'})`,
                                id: `${account.id}-${address.id || ''}`
                            }
                            account.DeActive ? map.set(newAccount.id, newAccount) : active.push(newAccount);
                            data.push(newAccount);
                        })
                    } else {
                        const newAccount = {
                            ...account,
                            Address_Id: null,
                            Broker: account?.Broker?.Brocker_Name,
                            Schedule: account?.Schedule?.Schedule_Name,
                            Transporter: account?.Transporter?.Transporter_Name,
                            DeActive: account.DeActive ? 'Yes' :  'No',
                            isActive: !account.DeActive,
                            accountId: account.id,
                            gstLedger: `${account.GSTIN_No || ''} \n\n(${account.ledgerAmount || '0.00'})`,
                            id: `${account.id}-`
                        }
                        account.DeActive ? map.set(newAccount.id, newAccount) : active.push(newAccount);
                        data.push(newAccount);
                    }
                // }
            });
            dispatch(setAccountDataInOption({
                accountsData: _.orderBy(data, ['Party_Name'], ['asc']),
                activeAccountsData: _.orderBy(active, ['Party_Name'], ['asc']),
                accountsMap: map
            }));  
        }
    }, [accounts, books]);

    return null;
}
